import { Button, CardBackground, Typography } from "@hellocarbo/lasagne";
import { Import, Wind } from "lucide-react";
import { useTranslation } from "react-i18next";

import UpsellOptionModal from "./UpsellOptionModal";
import UpsellPlanModal from "./UpsellPlanModal";

function EmptyView({
  urlNew,
  isScoreReadOnly,
  showUpsellPlanModal = false,
  showUpsellOptionModal = false,
}: {
  urlNew: string;
  isScoreReadOnly: boolean;
  showUpsellPlanModal?: boolean;
  showUpsellOptionModal?: boolean;
}) {
  const { t } = useTranslation("importDeposit");

  return (
    <CardBackground className="mt-sm">
      <Typography step="3" as="h1" weight="semibold">
        {t("importDeposit:title")}
      </Typography>
      <div className="text-center">
        <Wind className="size-md mx-auto" />
        <Typography as="h3" step="1" weight="bold" className="my-2xs">
          {t("importDeposit:newImport.noFileYet")}
        </Typography>
        {!isScoreReadOnly &&
          /* When in free trial, we want to push for a Plan upsell, not Options */
          (showUpsellPlanModal ? (
            <UpsellPlanModal show={showUpsellPlanModal}>
              <Button
                as="a"
                href={urlNew}
                intent="positive"
                shape="soft"
                size="small"
                className="text-center"
              >
                <Import className="size-sm" />
                {t("importDeposit:newImport.importFile")}
              </Button>
            </UpsellPlanModal>
          ) : (
            <UpsellOptionModal show={showUpsellOptionModal}>
              <Button
                as="a"
                href={urlNew}
                intent="positive"
                shape="soft"
                size="small"
                className="text-center"
              >
                <Import className="size-sm" />
                {t("importDeposit:newImport.importFile")}
              </Button>
            </UpsellOptionModal>
          ))}
      </div>
    </CardBackground>
  );
}

export default EmptyView;
